function editableChatMessage(message) {
  if (!message) return null;
  const id = message._replyContext ? message._replyContextSourceId : message.id;
  if (id == null || String(id).startsWith('context-')) return null;
  return {
    id,
    message: String(message.message || message.replyMessage || ''),
    tenant: Boolean(message._tenantMessage),
  };
}

const INSIDE_CHAT_DRAFT_KEY = 'inside-chat-composer-draft';

function loadInsideChatDraft(storage) {
  try {
    return String((storage && storage.getItem(INSIDE_CHAT_DRAFT_KEY)) || '');
  } catch {
    return '';
  }
}

function saveInsideChatDraft(storage, text) {
  const value = String(text || '');
  try {
    if (!value) storage.removeItem(INSIDE_CHAT_DRAFT_KEY);
    else storage.setItem(INSIDE_CHAT_DRAFT_KEY, value);
  } catch {
    /* ignore quota / private mode */
  }
}

function composerDraftText(modelValue, domValue) {
  const model = String(modelValue || '');
  const dom = domValue == null ? '' : String(domValue);
  return dom.length >= model.length ? dom : model;
}

function claimInsideChatSend(state) {
  if (!state || state.sending) return null;
  const text = String(state.text || '');
  const hasImages = !!state.hasImages;
  const hasAudio = !!state.hasAudio;
  if (!text.trim() && !hasImages && !hasAudio) return null;
  return { text, hasImages, hasAudio };
}

function detachChatReply(message) {
  if (!message || message._replyContext) return null;
  const id = message.id;
  if (id == null || String(id).startsWith('context-')) return null;
  if (!message.isReply) return null;
  return { id };
}

function replyParentKey(msg) {
  if (!msg || !msg.isReply || msg.isReplyTo == null || msg.isReplyTo === '') {
    return null;
  }
  return String(msg.isReplyTo);
}

function orderReplyThreadsToLatest(messages) {
  const rows = Array.isArray(messages) ? messages : [];
  const byId = new Map();
  const repliesByParent = new Map();
  const latestReplyIndex = new Map();
  rows.forEach((msg, index) => {
    if (msg && msg.id != null && !byId.has(String(msg.id))) {
      byId.set(String(msg.id), msg);
    }
    const key = replyParentKey(msg);
    if (key == null) return;
    if (!repliesByParent.has(key)) repliesByParent.set(key, []);
    repliesByParent.get(key).push(msg);
    latestReplyIndex.set(key, index);
  });
  if (!repliesByParent.size) return rows.slice();

  const ordered = [];
  rows.forEach((msg, index) => {
    if (replyParentKey(msg) == null) ordered.push(msg);
    for (const [key, latest] of latestReplyIndex) {
      if (latest !== index) continue;
      const parent = byId.get(key);
      if (parent) {
        ordered.push({
          ...parent,
          id: `context-${parent.id}`,
          isReply: false,
          isReplyTo: null,
          _replyContext: true,
          _replyContextSourceId: parent.id,
        });
      }
      ordered.push(...repliesByParent.get(key));
    }
  });
  return ordered;
}

function placeSentChatMessage(list, message) {
  const rows = Array.isArray(list) ? list.slice() : [];
  const id = message && message.id;
  if (id == null) {
    rows.push(message);
    return rows;
  }
  const idx = rows.findIndex((row) => row && row.id === id);
  if (idx === -1) {
    rows.push(message);
    return rows;
  }
  rows[idx] = { ...rows[idx], ...message, _locallyAdded: false };
  return rows;
}

module.exports = {
  claimInsideChatSend,
  composerDraftText,
  loadInsideChatDraft,
  saveInsideChatDraft,
  detachChatReply,
  editableChatMessage,
  orderReplyThreadsToLatest,
  placeSentChatMessage,
};
